import React, { FC, useState } from "react"
import css from "./SimCardEdit.module.scss"
import {
  PuxButton,
  PuxButtons,
  PuxContent,
  PuxDialogTitle,
  PuxFooter,
  PuxInput,
  PuxLabel,
  PuxSheet,
  PuxText,
  PuxToolbar,
  PuxTypography,
} from "@phonero/pux-react"

interface ISimCardEditProps {
  cardName: string | null | undefined
  onClose: () => void
  onChangeName: (newName: string) => void
  title: string
  label: string
  placeholder: string
  description: string
  cancel: string
  submit: string
}

export const SimCardEdit: FC<ISimCardEditProps> = ({
  cardName,
  onClose,
  onChangeName,
  title,
  label,
  placeholder,
  description,
  cancel,
  submit,
}) => {
  const [newName, setNewName] = useState<string>(cardName ?? "")

  const onSubmit = () => {
    if (cardName !== newName) onChangeName(newName)
    onClose()
  }

  const onNameChanged = (e: CustomEvent) => {
    setNewName(e.detail.value)
  }

  const canSubmit = () => {
    return cardName !== newName
  }

  return (
    <>
      <PuxDialogTitle>
        <PuxText style={{ fontSize: "2.6rem", fontWeight: 900 }}>
          {title}
        </PuxText>
      </PuxDialogTitle>
      <PuxContent>
        <PuxSheet color="light" className={css.modalContainer}>
          <div className={css.nameChangeContainer}>
            <div className={css.namChangeInputContainer}>
              <PuxLabel className={"top"}>{label}</PuxLabel>
              <PuxInput
                type="text"
                value={newName}
                onPuxChange={onNameChanged}
                pattern="text"
                required={true}
                placeholder={placeholder}
                title={label}
                maxlength={51} // Same maxlength as in Link
              />
            </div>
            <PuxTypography
              variant={"info-small"}
              component={"div"}
              className={css.subText}
            >
              {description}
            </PuxTypography>
          </div>
        </PuxSheet>
      </PuxContent>
      <PuxFooter className={css.footerContainer}>
        <PuxToolbar>
          <PuxButtons>
            <PuxButton
              onClick={onClose}
              color="light"
              fill="solid"
              className={css.footerButton}
            >
              <PuxText>{cancel}</PuxText>
            </PuxButton>
            <PuxButton
              onClick={onSubmit}
              color="primary"
              fill="solid"
              className={css.footerButton}
              disabled={!canSubmit()}
            >
              <PuxText>{submit}</PuxText>
            </PuxButton>
          </PuxButtons>
        </PuxToolbar>
      </PuxFooter>
    </>
  )
}
